import { CreditJurisdiction, CreditPlan, CreditPlanStatus } from '@/@types/client-api';
import { SpecialStatusSelector } from '../../CreditTracker/util/constants';

export const DEFAULT_AI_POWERED_TEXT = 'AI powered CLE compliance aid';
export const CREDIT_PLANS_DEBUG_COOKIE_NAME = 'credit_plans_debug_enabled';
export const CREDIT_PLANS_PRACTICEAREA_COOLDOWN_COOKIE_NAME = 'CREDITPLANS_PRACTICEAREA_COOLDOWN';
export const CREDIT_PLANS_SPECIAL_STATUS_COOKIE_NAME = 'CREDIT_PLANS_SPECIAL_STATUS';
export const CREDIT_PLANS_ANALYTICS_LIST_ITEM_NAME = 'PregeneratedCreditPlan';

export type CreditPlanJurisdiction = CreditJurisdiction & {
  status?: CreditPlanStatus;
  compliancePeriodEndDate?: string;
  flags?: string[];
  plan?: CreditPlan;
  isTransitionalOrNewlyAdmitted?: boolean;
  imagePortrait?: string;
  imagePortraitSrcSet?: string;
  imageLandscape?: string;
  imageLandscapeSrcSet?: string;
  sortOrder?: number;
};

export enum CreditPlansSparseDataFlowSteps {
  addLicense = 0,
  addComplianceInformation = 1,
  addPracticeAreas = 2,
  addSpecificPracticeAreas = 3
}

export type CreditPlansSpecialStatusCookie = Record<string, SpecialStatusSelector[]>;
